import React from 'react';
import Slider from 'react-slick';
import { Box } from '@mui/material';
import ImgResponsive from './ImgResponsive';


const CarouselBooking: React.FC = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  return (
    <Box sx={{ width: '100%', margin: '0 auto', padding: '0px 0px 0px 0px' }}>
      <Slider {...settings}>
        <div>
          <ImgResponsive src={'/images/GrpImages/GrpImages-21.jpg'} alt={'No Toll on EVs'}></ImgResponsive>
        </div>
        <div>
          <ImgResponsive src={'/images/GrpImages/GrpImages-20.jpg'} alt="Book a Premium Ride" />
        </div>
        <div>
          <ImgResponsive src={'/images/GrpImages/GrpImages-1.jpg'} alt="Book a Premium Ride" />
        </div>
        <div>
          <ImgResponsive src={'/images/GrpImages/GrpImages-10.jpg'} alt="Book a Premium Ride" />
        </div>
      </Slider>
    </Box >
  );
};

export default CarouselBooking;
